import { forwardRef, Ref } from 'react';
import MuiSelect, { SelectProps as MuiSelectProps } from '@mui/material/Select';
import { OverridableStringUnion } from '@mui/types';
import { InputBasePropsColorOverrides, InputBasePropsSizeOverrides } from '@mui/material/InputBase';

export * from '@mui/material/Select';

export interface SelectProps<T = unknown> extends MuiSelectProps<T> {
  /**
   * Internal color passes internal to outlined input component and also menu component for internal border
   */
  color?: OverridableStringUnion<
    'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'internal',
    InputBasePropsColorOverrides
  >;
  value?: T;
  defaultValue?: T;
  size?: OverridableStringUnion<'small' | 'medium' | 'large', InputBasePropsSizeOverrides>;
}

const Select = forwardRef(<T,>(props: SelectProps<T>, ref: Ref<HTMLDivElement>) => {
  const { color, MenuProps, ...other } = props;

  return (
    <MuiSelect
      ref={ref}
      color={color}
      MenuProps={{ color, BackdropProps: { invisible: true }, ...MenuProps }}
      {...other}
    />
  );
});

Select.displayName = 'Select';

export default Select as <T>(props: SelectProps<T> & { ref?: Ref<HTMLDivElement> }) => JSX.Element;
